const resetCounter = () => ({
  type: 'RESET',
})

export default resetCounter
